import Vue from 'vue';

const state = {
    data: [],
};

const getters = {
    getEntries(state) {
        return state.data;
    }
};

const mutations = {
    SET_DATA(state, stages) {
        state.data = stages;
    },
};

const actions = {

    setEntry: function ({dispatch, commit}) {
        commit('SET_DATA', {
            id: '',
            title: '',
            content: '',
            stage: [],
            finished: '',
            finish_date: '',
            documents: [],
        });
    },

    loadEntries: function ({dispatch, commit}, postID = 0) {

        const ID = postID || '';
        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().get("/wp/v2/tasks/" + ID)
                .then(({data}) => {

                    let taskRows = [];

                    if (data instanceof Array) {

                        data.forEach((task) => {

                            taskRows.push({
                                id: task.id,
                                title: task.title.rendered,
                                content: task.content.rendered,
                                stage: {
                                    value: task.acf.stage.ID,
                                    label: task.acf.stage.post_title,
                                },
                                finished: (task.acf.finished === true) ? '1' : '0',
                                finish_date: task.acf.finish_date,
                                documents: task.acf.documents || []
                            })

                        });

                    } else {

                        let contentRegex = /(<([^>]+)>)/ig;
                        let taskContent = data.content.rendered.replace(contentRegex, "");

                        taskRows = {
                            id: data.id,
                            title: data.title.rendered,
                            content: taskContent,
                            stage: {
                                value: data.acf.stage.ID,
                                label: data.acf.stage.post_title,
                            },
                            finished: (data.acf.finished === true) ? '1' : '0',
                            finish_date: data.acf.finish_date,
                            documents: data.acf.documents || []
                        }

                    }

                    commit('SET_DATA', taskRows);
                    resolve();

                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    updateEntry({dispatch, commit, state}) {

        const taskData = state.data;
        const ID = taskData.id || '';

        taskData.finish_date = Vue.moment(taskData.finish_date).format('YYYYMMDD');

        const documents = [];

        if (Array.isArray(taskData.documents) && taskData.documents.length > 0) {
            taskData.documents.forEach((item) => {
                documents.push({file: item.file.ID, title: item.title})
            });
        }


        const params = {
            title: taskData.title,
            content: taskData.content,
            fields: {
                stage: taskData.stage.value,
                finished: taskData.finished || '0',
                finish_date: taskData.finish_date,
                documents: documents,
            },
            status: 'publish'
        };

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().post("/wp/v2/tasks/" + ID, params)
                .then((response) => {
                    resolve();
                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    deleteEntry({dispatch, commit, state}) {

        const taskId = state.data.id;
        const params = {
            force: false
        };

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().delete("/wp/v2/tasks/" + taskId, {params})
                .then((response) => {
                    resolve();
                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        })

    }

};

export const tasks = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};